import React from 'react';
import MosaicImage from './MosaicImage';
import StandardImage from './StandardImage';
import { ImageDifficultySettings } from '../../types/difficulty';
import styles from './GameImage.module.css';

interface ImageContainerProps {
  imageUrl: string;
  filterCss: string;
  isMosaic: boolean;
  difficultySettings: ImageDifficultySettings;
  tileOrder: number[];
  imageDimensions: { width: number; height: number } | null;
  onImageLoad: (dimensions: { width: number; height: number }) => void;
  onTileLoad: () => void;
}

const ImageContainer: React.FC<ImageContainerProps> = ({
  imageUrl,
  filterCss,
  isMosaic,
  difficultySettings,
  tileOrder,
  imageDimensions,
  onImageLoad,
  onTileLoad,
}) => {
  return (
    <div className={styles.wrapper}>
      {isMosaic ? (
        <div className={styles.mosaicWrapper}>
          <MosaicImage
            imageUrl={imageUrl}
            filterCss={filterCss}
            tileOrder={tileOrder}
            imageDimensions={imageDimensions}
            onImageLoad={onImageLoad}
            onTileLoad={onTileLoad}
            difficultySettings={difficultySettings}
          />
        </div>
      ) : (
        <StandardImage 
          imageUrl={imageUrl} 
          filterCss={filterCss} 
          difficultySettings={difficultySettings}
          onLoad={onImageLoad} 
        />
      )}
    </div>
  );
};

export default ImageContainer;

